import currentSite, { CurrentSiteState } from "./currentSite/reducer";
import route, { RouterState } from "./route/reducer";
import user, { UserState } from "./user/reducer";
import sites, { SitesState } from "./sites/reducer";
import customers, { CustomersState } from "./customers/reducer";
import workflows, { WorkflowsState } from "./workflow/reducer";
import acl, { AclState } from "../../acl/reducer";
import flightReport, { FlightReportState } from "./flightReport/reducer";
import logger, { LoggerState } from "./logger/reducer";
import { combineReducers } from "redux";
import currentWorkflow from "./currentWorkflow/reducer";
import uiWorkflowViewPage from "./uiWorkflowViewPage/reducer";

export type GlobalState = {
  user: UserState;
  sites: SitesState;
  customers: CustomersState;
  workflows: WorkflowsState;
  route: RouterState;
  acl: AclState;
  flightReport: FlightReportState;
  logger: LoggerState;
  currentSite: CurrentSiteState;
};

// Make react-redux state automatically have the right type
declare module "react-redux" {
  interface DefaultRootState extends GlobalState {}
}

export const getRouterState = (state: GlobalState): RouterState => state.route;
export const getCurrentSiteState = (state: GlobalState): CurrentSiteState =>
  state.currentSite;
export const getUserState = (state: GlobalState): UserState => state.user;

export default combineReducers({
  acl,
  route,
  user,
  sites,
  customers,
  workflows,
  flightReport,
  logger,
  currentSite,
  currentWorkflow,
  uiWorkflowViewPage,
});
